import React from 'react'
import Header from '../Components/Header'
import Footer2 from '../Components/Footer2' 
import ParallaxSection2 from './ParallaxSection2'

export default function GraphicDesign() {
  return (
    <div> 
      <Header/>
      <main className="page_content">
        {/* <!-- Page Banner Section - Start
        ==================================================  --> */}

                                  {/* <!-- ======= ABOUT US CONTENT ======= --> */}
        <section
          className="page_banner_section text-center"
          style={{backgroundImage: `url(${'assets/images/graphicDesigning/graphic_img_9.jpg'})`,backgroundBlendMode:'overlay'}}>
          <div className="container">
            <h1 className="page_title mb-0 text-white">Graphic Designing</h1>
            <p className="text-white mt-2 myPara">At Netsole, our creative team fuses artistic vision with strategic insights to craft visually stunning graphics that define your brand's identity. We design with innovation and precision, ensuring every visual element captivates and engages your audience.
            </p>
          </div>
        </section>

        <section className='about_section section_space bg-light'>
          <div className='container'>
             <div className='row align-items-center justify-content-lg-between'>
                <div className='col-lg-6 order-lg-last'>
                    <div className='image_wrap'>
                        <img style={{borderRadius:'25px'}}  src='assets/images/graphicDesigning/graphic_img_7.webp' />
                    </div>
                </div>
                <div className='col-lg-5'>
                    <div className='about_content'>
                        <div className='heading_block'>
                            <h2 className='heading_text'>Elevate  Your  Brand  with  Innovative Graphic Design of  Netsole:</h2>
                            <p className='heading_description mb-2'>
                            At Netsole, we think that the core of your brand's identity is outstanding graphic design.  From creative logos and branding materials to captivating social media images and dynamic website layouts, our team of talented designers turns your idea into visually arresting components.  We create designs that captivate your target audience by utilizing a complex fusion of layout, font, and color theory. This guarantees that your message is not only noticeable but also makes an impact.
                            </p>
                            <p className='heading_description mb-0'> Netsole's creativity can help improve brand recognition, effectively convey your main points, and draw in customers in an increasingly visual digital environment.  Embrace the power of design to bring your brand to life with authenticity and flair.
                            </p>
                        </div>
                    </div>
                </div>
             </div>
          </div>
        </section>
        <section className='about_section section_space bg-light' style={{paddingTop:'60px'}}>
        <div className='container'>
             <div className='row align-items-center justify-content-lg-between'>
                <div className='col-lg-6 order-lg-first'>
                    <div className='image_wrap'>
                        <img style={{borderRadius:'25px'}}  src='assets/images/graphicDesigning/graphic_img_6.webp' />
                    </div>
                </div>
                <div className='col-lg-5'>
                    <div className='about_content'>
                        <div className='heading_block'>
                            <h2 className='heading_text'>Where Vision Meets Impact: <mark>The Art of Graphic Design</mark></h2>
                            <p className='heading_description mb-2'>
                            A dynamic combination of purposeful communication and artistic expression is graphic design.  Every design, in our opinion at Netsole, is an essential component of the narrative surrounding your brand.  Our gifted designers skillfully combine layout, typography, color theory, and images to turn your concepts into eye-catching works of art that enthrall and motivate.  Our work is intended to make a lasting impression on your audience, whether it is through an unforgettable logo, powerful branding collateral, or captivating digital content.
                            </p>
                            <p className='heading_description mb-0'> Accept the potential of design to convey your own story and enhance your brand identification.  Every visual component of Netsole is carefully designed to engage your audience more deeply and make your business stand out in the crowded market of today.
                            </p>
                        </div>
                    </div>
                </div>
             </div>
          </div>
        </section>
        <section className='about_section section_space bg-light' style={{paddingTop:'60px'}}>
        <div className='container'>
             <div className='row align-items-center justify-content-lg-between'>
                <div className='col-lg-6 order-lg-last'>
                    <div className='image_wrap'>
                        <img style={{borderRadius:'25px'}}  src='assets/images/graphicDesigning/graphic_img_8.jpg' />
                    </div>
                </div>
                <div className='col-lg-5'>
                    <div className='about_content'>
                        <div className='heading_block'>
                            <h2 className='heading_text'>Where Vision Meets Impact: <mark>The Art of Graphic Design</mark></h2>
                            <p className='heading_description mb-2'>
                            A dynamic combination of purposeful communication and artistic expression is graphic design.  Every design, in our opinion at Netsole, is an essential component of the narrative surrounding your brand.  Our gifted designers skillfully combine layout, typography, color theory, and images to turn your concepts into eye-catching works of art that enthrall and motivate.  Our work is intended to make a lasting impression on your audience, whether it is through an unforgettable logo, powerful branding collateral, or captivating digital content.
                            </p>
                            <p className='heading_description mb-0'> Accept the potential of design to convey your own story and enhance your brand identification.  Every visual component of Netsole is carefully designed to engage your audience more deeply and make your business stand out in the crowded market of today.
                            </p>
                        </div>
                    </div>
                </div>
             </div>
          </div>
        </section>
        <a className="hotline_block"
          href="https://wa.me/353862359495" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{position:'fixed',
            bottom:'50px',
            right:'20px',
            zIndex:'1000'
          }}
          >
          <span className="hotline_icon">
          <box-icon name='whatsapp' type='logo' animation='tada' color='white' size='lg' ></box-icon>
          </span>
        </a>
        </main>
        <ParallaxSection2/>
      <Footer2/>
    </div>
  )
}
